import { motion } from 'framer-motion';

export default function SimulatorCTA() {
  return (
    <section className="py-24 px-6 bg-gradient-to-br from-gray-900 via-gray-800 to-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-amber-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-600 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="inline-block px-4 py-1.5 bg-amber-500/20 border border-amber-500/30 rounded-full text-amber-400 text-sm font-medium mb-6">
            NEXT STEP
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            ラスベガス ビルボード投資を始める
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
            シミュレーション結果をもとに、専門家が最適な屋外広告ビルボード投資プランをご提案します。まずは無料相談から。
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="/#contact"
              className="px-8 py-4 bg-amber-500 text-black font-semibold rounded-full hover:bg-amber-400 transition-all cursor-pointer flex items-center gap-2 whitespace-nowrap"
            >
              <i className="ri-calendar-line text-xl"></i>
              無料投資相談を予約
            </a>
            <a
              href="/partnership"
              className="px-8 py-4 bg-white/10 text-white font-semibold rounded-full hover:bg-white/20 transition-all cursor-pointer border border-white/20 flex items-center gap-2 whitespace-nowrap"
            >
              <i className="ri-file-list-3-line text-xl"></i>
              投資資料をダウンロード
            </a>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-amber-400 text-3xl"></i>
              </div>
              <h3 className="text-white font-semibold mb-2">専門家サポート</h3>
              <p className="text-gray-400 text-sm">
                ビルボード投資のプロフェッショナルが丁寧にサポート
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-amber-400 text-3xl"></i>
              </div>
              <h3 className="text-white font-semibold mb-2">安心の実績</h3>
              <p className="text-gray-400 text-sm">
                127物件の運用実績と98%の高稼働率
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-amber-400 text-3xl"></i>
              </div>
              <h3 className="text-white font-semibold mb-2">迅速対応</h3>
              <p className="text-gray-400 text-sm">
                お問い合わせから24時間以内に初回ご連絡
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
